import React, { useEffect, useState } from 'react';
import css from './css.less';

//import Select from '@/src/components/Antd/Select/Select';
import Row from '@/src/components/Layouts/Row/Row';
import { OriCheckbox, Form } from 'src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import CustomCollapse from '@/src/components/Antd/SingleCollapse/Collapse';
import { EnumProductType } from 'src/types/common/product';
import { useSelector } from 'react-redux';
import NumberInput, {
  EnumMode,
} from '@/src/components/Antd/NumberInput/NumberInput';
import Configuration from '@/src/components/Configuration/Configuration';

import { instanceType, AllTypes } from 'src/tools/helper';
import { formatNumber } from 'src/tools/helper';
import { getReportingCurrencies } from '@/src/constrains/GlobalProvider/slice';
import { get } from 'lodash';
import { RenderSelectTable } from 'src/constrains/TaxRules';
import { TaxApplyType } from '@/src/types/common/tax';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import LocalPricingEditor from 'src/components/LocalPricing';
import { currencies } from '@/src/request/currency';
const Item = Form.Item;

const Pricing = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const currency = useSelector(getReportingCurrencies()) || '';
  const [currencyOptions, setCurrencyOptions] = useState([]);

  const {
    // advancedPriceSettingsOnChange,
    priceSettingsOnChange,
    advancedPriceSettings = [],
    priceSettings = {},
    //advancedPriceSettingsAddNew,
    advancedPriceSettingsOpen,
    setAdvancedPriceSettingsOpen,
    tableProps = {},
    columns = [],
    onExpandedRowsChange,
    expandedRowKeys,
    type,
    defaultSalePriceMismatchError,
    productUuid,
    disabled,
    storeDecimal = 2,
  } = props;
  const { error: mismatchError, help: mismatchHelp } =
    defaultSalePriceMismatchError || {};
  const { expandable, rowClassName } = tableProps;

  const {
    defaultSalePrice,
    cost,
    defaultSalePriceError,
    defaultRrp,
    localPrices = {},
  } = priceSettings;
  const canCalculate = React.useMemo(() => {
    return (
      instanceType(defaultSalePrice) === AllTypes.Number &&
      instanceType(cost) === AllTypes.Number
    );
  }, [defaultSalePrice, cost]);
  const margin = React.useMemo(() => {
    if (canCalculate && defaultSalePrice > 0) {
      const num = (defaultSalePrice - cost) / defaultSalePrice;
      let str = Number(num * 100).toFixed(storeDecimal);
      str += '%';
      return str;
    } else {
      return '-';
    }
  }, [defaultSalePrice, cost]);
  const profit = React.useMemo(() => {
    if (canCalculate) {
      return `${formatNumber(defaultSalePrice - cost)} ${currency}`;
    } else {
      return '-';
    }
  }, [defaultSalePrice, cost]);
  // const advancedOnDelete = React.useCallback((index) => {
  //   if (advancedPriceSettingsOnChange)
  //     advancedPriceSettingsOnChange(true, index);
  // }, []);
  const priceOnChange = (setting) => {
    if (priceSettingsOnChange) priceSettingsOnChange(setting);
  };
  const costOnChange = (e) => {
    priceOnChange({ cost: e });
  };
  const defaultPriceOnChange = (e) => {
    priceOnChange({ defaultSalePrice: e });
  };
  const defaultRrpOnChange = (e) => {
    priceOnChange({ defaultRrp: e });
  };

  const localPricesOnChange = (e) => {
    priceOnChange({ localPrices: e });
  };

  useEffect(() => {
    const fetchCurrencies = async () => {
      const result = await currencies();
      const filtered = result.filter((item: any) => !item.reportingCurrency);
      const formatted = filtered.map((item: any) => ({
        label: item.code,
        value: item.code,
      }));

      setCurrencyOptions(formatted);
    };

    fetchCurrencies();
  }, []);

  return (
    <SectionWrapper title={getI18n('allProducts.addproductset.pricing')}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightSubTitle={getI18n(
                  'allProducts.addproductset.pricing_ProductionSetPricingSection_component_rightSubTitle',
                )}
                title={getI18n(
                  'allProducts.addproductset.pricing_ProductionSetPricingSection_component_cost_per_title',
                )}>
                <NumberInput
                  mode={EnumMode.money}
                  size='large'
                  placeholder='0.0'
                  suffix={currency}
                  onChange={costOnChange}
                  value={cost}
                  disabled={disabled}
                  decimalPosition={storeDecimal}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <div className={css.contentContainer}>
                <div className={css.marginContainer}>
                  <span className={css.marginTitle}>
                    {getI18n(
                      'allProducts.addproductset.pricing_ProductionSetPricingSection_component_Margin',
                    )}
                  </span>
                  <span className={css.marginContent}>{margin}</span>
                </div>
                <div className={css.profitContainer}>
                  <span className={css.marginTitle}>
                    {getI18n(
                      'allProducts.addproductset.pricing_ProductionSetPricingSection_component_Profit',
                    )}
                  </span>
                  <span className={css.marginContent}>{profit}</span>
                </div>
              </div>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title=''>
                <Item name={'taxRulesEnabled'} valuePropName={'checked'}>
                  <OriCheckbox disabled={disabled}>
                    {getI18n(
                      'allProducts.addproductset.pricing_ProductionSetPricingSection_component_charge_tax',
                    )}
                  </OriCheckbox>
                </Item>
              </ItemWrapper>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const pV = get(p, 'taxRulesEnabled');
          const cV = get(c, 'taxRulesEnabled');
          return pV !== cV;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const checked = getFieldValue('taxRulesEnabled');
          if (checked) {
            return (
              <Item
                name={'taxRules'}
                rules={[
                  {
                    validator: async (x, value) => {
                      if (value.length < 1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'allProducts.addproductset.pricing_ProductionSetPricingSection_component_tax_rule_error',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <RenderSelectTable
                  disabled={disabled}
                  productUuid={productUuid}
                  applyTypes={
                    productUuid
                      ? [
                          TaxApplyType.HsCode,
                          TaxApplyType.All,
                          TaxApplyType.Specific,
                        ]
                      : [TaxApplyType.All]
                  }
                />
              </Item>
            );
          }
          return null;
        }}
      </Item>
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const pV = get(p, 'taxRulesEnabled');
          const cV = get(c, 'taxRulesEnabled');
          return pV !== cV;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const checked = getFieldValue('taxRulesEnabled');
          if (checked) {
            return (
              <div className={css.bottomJump1}>
                <Row
                  elements={[
                    {
                      child: (
                        <Configuration
                          linkTo='/settings/tax/list'
                          configStart={getI18n(
                            'allProducts.addproductset.pricing_ProductionSetPricingSection_component_configStart',
                          )}
                          configLink={getI18n(
                            'allProducts.addproductset.pricing_ProductionSetPricingSection_component_configLink',
                          )}
                          configEnd={getI18n(
                            'allProducts.addproductset.pricing_ProductionSetPricingSection_component_configEnd',
                          )}
                        />
                      ),
                    },
                  ]}
                />
              </div>
            );
          } else {
            return null;
          }
        }}
      </Item>

      <Row
        borderBottomClassName={css.borderBottom}
        elements={[
          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_title',
                )}*`}
                {...(type === EnumProductType.Set
                  ? {
                      rightSubTitle: getI18n(
                        'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_rightSubTitle',
                      ),
                    }
                  : {})}
                id='productDefaultPriceSetting'
                belowComponentTitle={
                  defaultSalePrice
                    ? ''
                    : getI18n(
                        'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_price_zero',
                      )
                }>
                <NumberInput
                  disabled={disabled}
                  value={defaultSalePrice}
                  mode={EnumMode.money}
                  error={defaultSalePriceError || mismatchError}
                  help={
                    mismatchError
                      ? mismatchHelp
                      : getI18n(
                          'allProducts.addproductset.pleasefillintheprice',
                        )
                  }
                  onChange={defaultPriceOnChange}
                  onBlur={() => {
                    if (defaultSalePrice === '' || defaultSalePrice == null) {
                      defaultPriceOnChange(0);
                    }
                  }}
                  size='large'
                  placeholder='0.0'
                  suffix={currency}
                  decimalPosition={2}
                />
              </ItemWrapper>
            ),
          },

          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'allProducts.addproductset.defaultRecommendRetailPrice',
                )}`}
                id='productDefaultRrp'>
                <NumberInput
                  disabled={disabled}
                  value={defaultRrp}
                  mode={EnumMode.money}
                  // error={defaultSalePriceError || mismatchError}
                  // help={
                  //   mismatchError
                  //     ? mismatchHelp
                  //     : getI18n(
                  //         'allProducts.addproductset.pleasefillintheprice',
                  //       )
                  // }
                  onChange={defaultRrpOnChange}
                  size='large'
                  placeholder=''
                  suffix={currency}
                  decimalPosition={2}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        hasBottomBorder
        borderBottomClassName={css.borderBottom}
        elements={[
          {
            child: (
              <>
                <div id='localPrices' className={css.localPrices}>
                  <LocalPricingEditor
                    value={localPrices}
                    onChange={localPricesOnChange}
                    currencyOptions={currencyOptions}
                    fields={[
                      {
                        key: 'salePrice',
                        label: getI18n('allProducts.addproductset.listPrice'),
                        placeholder: 'Sale Price',
                      },
                      {
                        key: 'rrp',
                        label: getI18n(
                          'allProducts.addproductset.recommendRetailPrice',
                        ),
                        placeholder: 'RRP',
                      },
                    ]}
                    source='product'
                  />
                </div>
              </>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <CustomCollapse
                open={advancedPriceSettingsOpen}
                header={getI18n(
                  'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_price_setting',
                )}
                setOpen={setAdvancedPriceSettingsOpen}
                className={css.collapse}>
                <ItemWrapper
                  id='ProductAdvancedPriceSetting'
                  title={getI18n(
                    'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_managing_otherprices',
                  )}
                  bottomTitle={getI18n(
                    'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_bottomTitle',
                  )}>
                  <EditableTable
                    disableAdd={advancedPriceSettings.length >= 10}
                    data={advancedPriceSettings}
                    columns={columns}
                    id='PriceSettingsTable'
                    expandable={expandable}
                    rowClassName={rowClassName}
                    onExpandedRowsChange={onExpandedRowsChange}
                    expandedRowKeys={expandedRowKeys}
                  />
                </ItemWrapper>
                <Configuration
                  linkTo='/settings/product'
                  configStart={getI18n(
                    'allProducts.addproductset.pricing_ProductionSetPricingSection_component_sales_price_set_pricetier',
                  )}
                  configLink={getI18n(
                    'general.storeCommunicationSetting.product',
                  )}
                  configEnd={getI18n(
                    'allProducts.addproductset.pricing_ProductionSetPricingSection_component_configEnd',
                  )}
                />
              </CustomCollapse>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default Pricing;
